import './HeroKpis.css';
import { AnimatedNumber } from '../../components/AnimatedNumber';
import { t } from '../../copy/strings';
import { fmtInt, fmtPct } from '../../format/numbers';
import { useLayout } from '../../state/hooks';

export interface HeroKpisProps {
  /** `national.validVotes`. */
  validVotes: number;
  /** `national.turnoutRate` = turnout ÷ electorate_counted. */
  turnoutRate: number;
  /** `national.blankNullRate` = (blank_votes + null_votes) ÷ turnout. */
  blankNullRate: number;
  /** Primeiro snapshot dentro da janela `intro` (§7.2 bloco 5). */
  intro?: boolean;
}

const pct1 = (v: number): string => fmtPct(v, 1);

/**
 * Votos válidos · Comparecimento · Brancos e nulos (§7.10), sempre em --color-fg-1 (o esmaecido não se aplica). Poda
 * por altura com `.u-no-mid.u-no-tiny` (§4.5.2, AC-7.10-02); não renderizado no `land` nem na TV (§7.2 bloco 6).
 */
export function HeroKpis({ validVotes, turnoutRate, blankNullRate, intro = false }: HeroKpisProps) {
  const mode = useLayout().mode;
  if (mode === 'land' || mode === 'tv') return null;
  return (
    <dl class="hero-kpis u-no-mid u-no-tiny" data-testid="hero-kpis">
      <div class="hero-kpis__item">
        <dt class="hero-kpis__key">{t('kpi.valid')}</dt>
        <dd class="hero-kpis__value">
          <AnimatedNumber value={validVotes} format={fmtInt} intro={intro} />
        </dd>
      </div>
      <div class="hero-kpis__item">
        <dt class="hero-kpis__key">{t('kpi.turnout')}</dt>
        <dd class="hero-kpis__value">
          <AnimatedNumber value={turnoutRate} format={pct1} intro={intro} />
        </dd>
      </div>
      <div class="hero-kpis__item">
        <dt class="hero-kpis__key">{t('kpi.blankNull')}</dt>
        <dd class="hero-kpis__value">
          <AnimatedNumber value={blankNullRate} format={pct1} intro={intro} />
        </dd>
      </div>
    </dl>
  );
}
